import React, { useState } from 'react';
import { Routes, Route, Outlet } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Home from './pages/Home/Home';
import Cart from './pages/Cart/Cart';
import PlaceOrder from './pages/PlaceOrder/PlaceOrder';
import Footer from './components/Footer/Footer';
import Login from './pages/Login/Login';
import Menu from './menu/menu';
import MenuPage from './components/MenuPage/MenuPage';



// This Layout component ensures Navbar and Footer stay visible on specific routes
const Layout = ({ setShowLogin }) => (
  <>
    <Navbar setShowLogin={setShowLogin} />
    <Outlet /> {/* This renders the specific child route (Home, Cart, etc.) */}
    <Footer />
  </>
);

const App = () => {
  const [showlogin, setShowLogin] = useState(false);

  return (
    <div className='app'>
      <Routes>
        {/* Layout Wrapper Routes */}
        <Route element={<Layout setShowLogin={setShowLogin} />}>
          <Route path='/' element={<Home />} />
          <Route path='/menu' element={<Menu />} />
          <Route path='/cart' element={<Cart />} />
          <Route path='/order' element={<PlaceOrder />} />
          <Route path='/login' element={<Login setShowLogin={setShowLogin} />} />
        </Route>

        {/* Dynamic POS Store Route */}
        {/* Note: This is only the menu route for a specific store... which is use by qr code scanner (temporary) */}
        <Route path="/:storeid/menu" element={<MenuPage />} />
      </Routes>
    </div>
  );
}

export default App;